var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "mural-kpis", class: { "mural-kpis--scroll": _vm.scroll } },
    [
      _vm.summary.revenue
        ? _c("div", { staticClass: "mural-kpi" }, [
            _c(
              "span",
              { staticClass: "mural-kpi__icon mural-kpi__icon--success" },
              [
                _c("feather-icon", {
                  attrs: { icon: "DollarSignIcon", size: "20" },
                }),
              ],
              1
            ),
            _c("div", { staticClass: "mural-kpi__body" }, [
              _c("div", { staticClass: "mural-kpi__value hb-money" }, [
                _vm._v(_vm._s(_vm.money(_vm.summary.revenue.net))),
              ]),
              _c("div", { staticClass: "mural-kpi__label" }, [
                _vm._v(_vm._s(_vm.$t("mural.kpi.revenue"))),
              ]),
              _c(
                "div",
                {
                  staticClass: "mural-kpi__foot",
                  class: _vm.deltaClass(_vm.summary.revenue.delta_pct),
                },
                [
                  _vm._v(
                    " " +
                      _vm._s(_vm.formatPercent(_vm.summary.revenue.delta_pct)) +
                      " " +
                      _vm._s(_vm.comparisonLabel) +
                      " "
                  ),
                ]
              ),
            ]),
            _c(
              "span",
              {
                staticClass: "mural-kpi__eye",
                attrs: { title: _vm.$t("mural.kpi.toggle_values") },
                on: {
                  click: function ($event) {
                    return _vm.$emit("toggle-values")
                  },
                },
              },
              [
                _c("feather-icon", {
                  attrs: {
                    icon: _vm.moneyHidden ? "EyeIcon" : "EyeOffIcon",
                    size: "17",
                  },
                }),
              ],
              1
            ),
          ])
        : _vm._e(),
      _c("div", { staticClass: "mural-kpi" }, [
        _c(
          "span",
          { staticClass: "mural-kpi__icon mural-kpi__icon--primary" },
          [_c("feather-icon", { attrs: { icon: "CalendarIcon", size: "20" } })],
          1
        ),
        _c("div", { staticClass: "mural-kpi__body" }, [
          _c("div", { staticClass: "mural-kpi__value" }, [
            _vm._v(_vm._s(_vm.summary.lessons.scheduled)),
          ]),
          _c("div", { staticClass: "mural-kpi__label" }, [
            _vm._v(_vm._s(_vm.$t("mural.kpi.lessons"))),
          ]),
          _c("div", { staticClass: "mural-kpi__foot text-muted" }, [
            _vm._v(
              " " +
                _vm._s(
                  _vm.$t("mural.kpi.lessons_sub", {
                    done: _vm.summary.lessons.done,
                  })
                ) +
                " "
            ),
          ]),
        ]),
      ]),
      _c("div", { staticClass: "mural-kpi" }, [
        _c(
          "span",
          { staticClass: "mural-kpi__icon mural-kpi__icon--info" },
          [_c("feather-icon", { attrs: { icon: "PieChartIcon", size: "20" } })],
          1
        ),
        _c("div", { staticClass: "mural-kpi__body" }, [
          _c("div", { staticClass: "mural-kpi__value" }, [
            _vm._v(_vm._s(_vm.percent(_vm.summary.occupancy.rate))),
          ]),
          _c("div", { staticClass: "mural-kpi__label" }, [
            _vm._v(_vm._s(_vm.$t("mural.kpi.occupancy"))),
          ]),
          _c(
            "div",
            {
              staticClass: "mural-kpi__foot",
              class: _vm.deltaClass(_vm.summary.occupancy.delta_pp),
            },
            [
              _vm._v(
                " " +
                  _vm._s(_vm.formatPoints(_vm.summary.occupancy.delta_pp)) +
                  " " +
                  _vm._s(_vm.comparisonLabel) +
                  " "
              ),
            ]
          ),
        ]),
      ]),
      _c("div", { staticClass: "mural-kpi" }, [
        _c(
          "span",
          { staticClass: "mural-kpi__icon mural-kpi__icon--warning" },
          [_c("feather-icon", { attrs: { icon: "UserPlusIcon", size: "20" } })],
          1
        ),
        _c("div", { staticClass: "mural-kpi__body" }, [
          _c("div", { staticClass: "mural-kpi__value" }, [
            _vm._v(_vm._s(_vm.summary.new_students.total)),
          ]),
          _c("div", { staticClass: "mural-kpi__label" }, [
            _vm._v(_vm._s(_vm.$t("mural.kpi.new_students"))),
          ]),
          _c("div", { staticClass: "mural-kpi__foot text-muted" }, [
            _vm._v(
              " " +
                _vm._s(
                  _vm.$t("mural.kpi.new_students_sub", {
                    plan: _vm.summary.new_students.by_plan,
                    single: _vm.summary.new_students.single,
                  })
                ) +
                " "
            ),
          ]),
        ]),
      ]),
      _c("div", { staticClass: "mural-kpi" }, [
        _c(
          "span",
          { staticClass: "mural-kpi__icon mural-kpi__icon--danger" },
          [_c("feather-icon", { attrs: { icon: "XCircleIcon", size: "20" } })],
          1
        ),
        _c("div", { staticClass: "mural-kpi__body" }, [
          _c("div", { staticClass: "mural-kpi__value" }, [
            _vm._v(_vm._s(_vm.summary.disruptions.total)),
          ]),
          _c("div", { staticClass: "mural-kpi__label" }, [
            _vm._v(_vm._s(_vm.$t("mural.kpi.disruptions"))),
          ]),
          _c("div", { staticClass: "mural-kpi__foot text-muted" }, [
            _vm._v(
              " " +
                _vm._s(
                  _vm.$t("mural.kpi.disruptions_sub", {
                    cancelled: _vm.summary.disruptions.cancelled,
                    rescheduled: _vm.summary.disruptions.rescheduled,
                  })
                ) +
                " "
            ),
          ]),
        ]),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }